import { render, staticRenderFns } from "./ServiceLaundryBreakdown.vue?vue&type=template&id=5ad6011e&scoped=true"
import script from "./ServiceLaundryBreakdown.vue?vue&type=script&lang=js"
export * from "./ServiceLaundryBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad6011e",
  null
  
)

export default component.exports